import moment from "moment";

export function formatBrDate(data: string) {
  return moment(data).utc(false).format("DD/MM/YYYY");
}

export function formatBrDateHour(data: string) {
  return moment(data).utc(false).format("DD/MM/YYYY [às] HH:mm");
}


export function formatBrDateHourUTC(data: string) {
  return moment(data).utc(true).format("DD/MM/YYYY [às] HH:mm");
}
